// Ce qui a changé entre deux versions d'une proposition, pour le montrer à l'écran
// quand Nexus (ou un collègue) modifie le deck pendant qu'on le regarde.
// Résultat : { slideId: { title: bool, blocks: [blockId] } }, seulement pour les slides touchées.
const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);

const HEAD = ["layout", "title", "subtitle", "tag", "hidden"];

export const diffProposal = (previous, next) => {
  const changes = {};
  if (!previous || !next) return changes;
  const before = Object.fromEntries((previous.slides || []).map((slide) => [slide.id, slide]));
  const metaChanged = !same(previous.meta, next.meta);
  (next.slides || []).forEach((slide) => {
    const old = before[slide.id];
    const blocks = slide.blocks || [];
    if (!old) {
      changes[slide.id] = { title: true, blocks: blocks.map((block) => block.id) };
      return;
    }
    const oldBlocks = Object.fromEntries((old.blocks || []).map((block) => [block.id, block]));
    const changedBlocks = blocks.filter((block) => !same(block, oldBlocks[block.id])).map((block) => block.id);
    // Couverture et conditions affichent la référence, les dates et les conditions de règlement.
    const title = HEAD.some((key) => !same(slide[key], old[key]))
      || (metaChanged && ["cover", "conditions"].includes(slide.layout));
    const removed = (old.blocks || []).some((block) => !blocks.some((item) => item.id === block.id));
    if (title || changedBlocks.length || removed) changes[slide.id] = { title: title || removed, blocks: changedBlocks };
  });
  return changes;
};

export const mergeChanges = (current, added) => {
  const merged = { ...current };
  Object.entries(added).forEach(([slideId, change]) => {
    const existing = merged[slideId] || { title: false, blocks: [] };
    merged[slideId] = { title: existing.title || change.title, blocks: [...new Set([...existing.blocks, ...change.blocks])] };
  });
  return merged;
};
